import React, { useEffect } from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import StoriesIndex from 'components/StoriesIndex'
import { StoriesStore } from 'stores/stories'
import { getVideosFeedNavOptions } from 'utils'
import { useDatePagination, useStore, useFeedPageView } from 'hooks'
import { getStaticWrapper } from 'utils'
import optimize from 'lib/pixels/optimize'

const VideosLatestPage = ({ items }) => {
  const storiesStore = useStore(StoriesStore, { items })
  const pagination = useDatePagination(storiesStore.items, (query) =>
    storiesStore.findNext({ ...query, type: 'barstool_original' })
  )
  useFeedPageView(pagination)

  const adSettings = {
    slot: 'section',
    revContentSlot: 'Feed',
    keyValues: {}
  }
  useEffect(() => {
    optimize.activate('optimize.activate')
  }, [])
  return (
    <SiteLayout feedNavOptions={getVideosFeedNavOptions('/videos')} adSettings={adSettings}>
      <Head
        title='Barstool Sports Latest Videos & Video Archive | Barstool Sports'
        description='Watch the latest original videos from Barstool Sports including Pizza Reviews, Chicks in the Office, The Barstool Rundown and more.'
      />
      <StoriesIndex {...pagination} adSettings={adSettings} />
    </SiteLayout>
  )
}

export const getStaticProps = getStaticWrapper(async () => {
  const items = await StoriesStore().find({ type: 'barstool_original' })
  return { items }
})

export default VideosLatestPage
